var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuddyCaseMountain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "652.286mm",
    height: "390.172mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 65228.6 39017.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil0",
    points: "65228.45,39016.87 -0.01,39016.87 6656.26,26765.11 9088.29,22999.24 10005.68,24284.36 11307.49,23779.51 13753.4,20063.82 16370.37,18892.67 21760.82,20211.92 23823.42,17752.04 24740.45,17361.12 24322.04,17157.41 27407.07,13478.25 29455.17,14228.01 31329.14,12006.54 32353.16,11905.46 33294.84,10158.32 34696.49,10724.79 38003.42,4143.84 39075.54,6355.26 39221.59,6656.84 39311.5,6823.45 41294.87,9563.03 43854.98,10895.85 44878.7,15977.37 49038.78,18143.23 51598.63,21474.81 55298.26,27133.25 61622.69,30137.75 65228.45,39012.49 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "11307.45,23779.42 9623.26,26147.57 9088.47,22999.15 10005.68,24284.54 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "4792.74,30195.19 5802.89,39016.87 9103.24,31720.68 6641.98,32577.79 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "27407.02,13478.25 28953.96,13880.87 30136.06,13420.86 29078.35,14843.5 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "59602.04,39016.87 5802.89,39016.87 6400.23,34401.22 9103.28,31720.55 10959.33,30470.97 18575.16,22042.92 21206.14,28209.01 26767.06,16893.69 31566.79,20891.7 36559.16,14394.57 38992.61,27133.25 42628.71,26300.25 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "17493.96,33873.64 19968.7,34606.1 22784.84,39016.87 16725.92,36261.67 17493.96,33873.64 16725.92,36261.67 17493.96,33873.64 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil0",
    points: "17493.96,33873.64 12558.72,39016.87 16725.92,36261.67 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "41324.15,39016.87 37824.22,35577.28 36808.2,34579.19 31296.17,29163.28 28502.36,34090.16 22784.84,39016.87 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "31296.17,29163.28 37355.72,35117.18 39169.36,34090.16 41324.15,39016.87 37633.37,39016.87 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "36558.8,14394.48 40307.41,17139 44878.7,15977.37 38992.61,27133.25 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "42628.71,26300.25 45484.63,22042.92 48599.24,23988.34 50220.39,22042.92 51603.97,33025.03 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "34696.35,10724.61 35926.63,9188.17 36558.8,10520.99 37441.45,6938.94 38060.23,7357.71 38444.03,6550.21 39294.24,6791.15 38003.06,4143.67 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "43854.98,10895.85 40307.41,17139.17 41294.87,9563.03 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "18575.16,22042.92 21504.79,22766.56 23247.16,24055.78 21206.14,28209.01 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "26767.02,16893.47 29185.08,20128.64 31566.93,20891.83 32802.63,19283.54 30913.13,19267.84 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "38992.61,27133.25 42628.71,26300.25 44878.7,15977.37 40452.09,20891.83 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "26254.6,27513.62 27646.28,25561.57 29217.51,24830.99 30891.29,23335.21 30626.49,24439.45 29806.71,24664.91 28829,25885.49 27990.93,25729.65 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "43652.12,31330.92 44296.62,30174.05 45072.22,29718.27 45535.79,28357.47 46451.35,28105.67 45832.08,28666.57 45535.79,29220.23 45508.65,29893.6 44593.09,30244.17 43306.4,32954.29 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "9949.67,35120.39 10388.81,34443.58 11128.34,34187.95 11729.19,33059.95 12665.13,33150.17 11890.95,33420.93 11682.97,33887.16 11474.99,33887.16 11307.45,34759.43 10585.23,34518.81 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "53228.67,36733.68 53762.08,36053.53 54508.59,36053.53 54999.3,35331.38 55724.45,35411.82 55052.68,35636.89 54775.08,35928.29 54689.66,36220.03 53943.6,36150.54 53825.7,36589.38 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "65228.45,39015.22 57644.56,31985.43 53591.25,30529.87 51603.97,33025.03 50220.39,22042.92 51598.63,21474.81 55298.26,27133.25 61622.69,30137.75 65228.45,39012.49 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "57644.56,31985.43 53591.25,30529.87 51603.97,33025.03 59602.04,39016.87 65228.45,39016.87 65228.45,39015.22 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "33294.84,10158.32 34575.52,10271.1 35065.83,9989.36 34696.35,10724.61 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil0",
    points: "22784.84,39016.87 28274.81,37242.74 31296.17,29163.28 28502.36,34090.16 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "39294.24,6791.15 40307.41,10367.11 40307.41,17139.17 41294.87,9563.03 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "27407.02,13478.25 22848.86,18046.06 20248.04,19841.69 21760.82,20211.92 23823.42,17752.04 24740.45,17361.12 24322.04,17157.41 "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuddyCaseMountain);
export default __webpack_public_path__ + "static/media/buddy_case_mountain.e98db502a326ee403650ffb84241933d.svg";
export { ForwardRef as ReactComponent };